import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { environment } from '../../../../../environments/environment';
import { ToastrService } from 'ngx-toastr';
import { ConsoleLogger } from '../../../../core/utilities/console-logger';
import { Area } from '../../../../core/constants/area';

@Component({
    selector: 'app-create-checklists',
    templateUrl: './create-checklists.component.html',
    styleUrls: ['./create-checklists.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class CreateCheckListsComponent implements OnInit {

    creatingChecklists = false;
    checklistCount = 0;

    irpCompanyId = 7340;

    checklistCompanyId = 7340;
    checklistDueDate: Date = null;
    checklistEndDate: Date = null;
    checklistListOfCompanies: string;
    checklistLoading = 0.34;
    checklistStartDate: Date = new Date();
    checklistTermType = 1;
    checklistUseOneCompany = true;
    checklistIftaQuarterlyCompanyId = 7340;
    checklistIftaQuarterlyListOfCompanies: string;
    checklistIftaQuarterlyTermChecklist = 0;
    checklistIftaQuarterlyYear: number = new Date().getFullYear();
    irpMonth: string = null;
    isRunningChecklistBuild = false;
    nyHutCompanyId = 7340;
    nyHutYear: number = new Date().getFullYear();
    ucrCompanyId = 7340;
    scacCompanyId = 7340;
    scacYear: number = new Date().getFullYear();
    hazmatCompanyId = 7340;
    hazmatYear: number = new Date().getFullYear();
    nmMTRCompanyId = 7340;
    nmMTRYear: number = new Date().getFullYear();

    //ucrMonth does not appear to be used, but I am leaving it in for now (developer portal refactor). BP - 09/25/2025 10:26 AM
    ucrMonth: string = null;
    ucrYear: number;

    actions = [
        { label: 'Auto-Create All IFTA Miles/Fuel Entry Checklists', action: () => this.runCreateAllMonthlyIftaFuelChecklist() },
        { label: 'Auto-Create All IFTA Quarterly Checklists', action: () => this.runCreateAllIftaQuarterlyChecklist() },
        { label: 'Auto-Create ALL MTR Monthly Checklists', action: () => this.runCreateAllMtrMonthlyChecklist() },
        { label: 'Auto-Create All IRP Renewal Checklists', action: () => this.createIrpRenewalChecklist(true) },
        { label: 'Auto-Create All UCR Filing Checklists', action: () => this.createUcrRenewalChecklist(true) },
        { label: 'Auto-Create All NY HUT Renewal Checklists', action: () => this.createNyHutRenewalChecklist() },
        { label: 'Auto-Create All IFTA Renewal Checklists', action: () => this.createIftaRenewalChecklist() },
        { label: 'Auto-Create All Update US DOT Checklists', action: () => this.createDotUpdateChecklist() },
        { label: 'Auto-Create All 2290 Checklists For This Year', action: () => this.create2290Checklist() },
        { label: 'Auto-Create All NM MTR Renewal Checklists', action: () => this.createNMMTRRenewalChecklist(true) },
    ]

    selectedTask: any;

    constructor(
        private http: HttpClient,
        private toastrService: ToastrService
    ) { }

    ngOnInit() {
        this.makeFirstOfMonth();
    }

    createDotUpdateChecklist() {
        this.creatingChecklists = true;
        this.http
            .post<any>(
                `${environment.dotNetApiUrl}/${Area.transportation}/checklists/DotUpdateCreation`,
                {}
            )
            .subscribe(
                (x) => {
                    ConsoleLogger.logInfo(x);
                    this.checklistCount = x.length;
                    this.toastrService.success(
                        'Creating DOT update checklists was successfully run.'
                    );
                    this.creatingChecklists = false;
                },
                (err) => {
                    console.error('Error:', err);
                    this.toastrService.error(
                        'Creating DOT update checklists failed to run.'
                    );
                    this.creatingChecklists = false;
                }
            );
    }

    createIftaMilesFuelChecklist() {
        this.checklistLoading = 0;
        this.isRunningChecklistBuild = true;
        let title = 'test title';
        if (this.checklistTermType == 1) {
            const year: number = this.checklistStartDate.getFullYear();
            const month: string = (this.checklistStartDate.getMonth() + 1)
                .toString()
                .padStart(2, '0');
            title = year + month;
        } else if (this.checklistTermType == 3) {
            const year: number = this.checklistStartDate.getFullYear();
            switch (this.checklistStartDate.getMonth()) {
                case 0:
                    title = year + ' - Q1';
                    break;
                case 3:
                    title = year + ' - Q2';
                    break;
                case 6:
                    title = year + ' - Q3';
                    break;
                case 9:
                    title = year + ' - Q4';
                    break;
                default:
                    this.isRunningChecklistBuild = false;
                    this.toastrService.warning(
                        'Quarter must begin in the 1st, 4th, 7th, or 10th month.'
                    );
                    return;
            }
        }
        if (this.checklistUseOneCompany) {
            this.createOneIFTAMilesFuelChecklist({
                CompanyId: this.checklistCompanyId,
                ChecklistId: 3,
                StartDate: this.checklistStartDate,
                EndDate: this.checklistEndDate,
                Title: title,
                UseIFTAAgent: true,
            });
        } else {
            this.createManyIFTAMilesFuelChecklist({
                CompanyId: this.checklistCompanyId,
                ChecklistId: 3,
                StartDate: this.checklistStartDate,
                EndDate: this.checklistEndDate,
                Title: title,
                UseIFTAAgent: true,
            });
        }
    }

    createIftaRenewalChecklist() {
        this.creatingChecklists = true;
        this.http
            .post<any>(
                `${environment.dotNetApiUrl}/${Area.transportation}/checklists/IftaRenewalCreation`,
                {}
            )
            .subscribe(
                (x) => {
                    ConsoleLogger.logInfo(x);
                    this.checklistCount = x.length;
                    this.toastrService.success(
                        'Creating IFTA renewal checklists was successfully run.'
                    );
                    this.creatingChecklists = false;
                },
                (err) => {
                    console.error('Error:', err);
                    this.toastrService.error(
                        'Creating IFTA renewal checklists failed to run.'
                    );
                    this.creatingChecklists = false;
                }
            );
    }

    createIftaQuarterlyChecklist() {
        this.checklistLoading = 0;
        this.isRunningChecklistBuild = true;
        let endDate: Date;
        let title = 'Quarterly test title';
        switch (+this.checklistIftaQuarterlyTermChecklist) {
            case 0:
                title = 'Quarterly ' + this.checklistIftaQuarterlyYear + ' - Q1';
                endDate = new Date(this.checklistIftaQuarterlyYear, 2, 31);
                break;
            case 1:
                title = 'Quarterly ' + this.checklistIftaQuarterlyYear + ' - Q2';
                endDate = new Date(this.checklistIftaQuarterlyYear, 5, 30);
                break;
            case 2:
                title = 'Quarterly ' + this.checklistIftaQuarterlyYear + ' - Q3';
                endDate = new Date(this.checklistIftaQuarterlyYear, 8, 30);
                break;
            case 3:
                title = 'Quarterly ' + this.checklistIftaQuarterlyYear + ' - Q4';
                endDate = new Date(this.checklistIftaQuarterlyYear, 11, 31);
                break;
            default:
                this.isRunningChecklistBuild = false;
                this.toastrService.warning(
                    'Quarter must begin in the 1st, 4th, 7th, or 10th month.'
                );
                return;
        }

        if (this.checklistUseOneCompany) {
            this.createOneIFTAQuarterlyChecklist({
                CompanyId: this.checklistIftaQuarterlyCompanyId,
                ChecklistId: 10,
                EndDate: endDate,
                Title: title,
                UseIFTAAgent: true,
            });
        } else {
            this.createManyQuarterlyChecklist({
                CompanyId: this.checklistIftaQuarterlyCompanyId,
                ChecklistId: 10,
                EndDate: endDate,
                Title: title,
                UseIFTAAgent: true,
            });
        }
    }

    createIrpRenewalChecklist(createAll: boolean) {
        let pushData = {};
        if (createAll) {
            pushData = { companyId: 0 };
        } else {
            pushData = {
                companyId: this.irpCompanyId,
                Year: new Date().getFullYear(),
            };
        }
        this.creatingChecklists = true;
        this.http
            .post<any>(
                `${environment.dotNetApiUrl}/${Area.transportation}/checklists/IrpChecklistCreation`,
                pushData
            )
            .subscribe(
                (response) => {
                    ConsoleLogger.logInfo(response);
                    if (response == null) {
                        this.toastrService.warning(
                            `Company ${pushData} has no units to create a checklist from.`
                        );
                    } else {
                        this.toastrService.success(
                            'Creating IRP renewal checklist successfully run.'
                        );
                    }
                    this.creatingChecklists = false;
                },
                (err) => {
                    this.creatingChecklists = false;
                }
            );
    }

    async createManyIFTAMilesFuelChecklist(pushData) {
        if (!this.checklistListOfCompanies || this.checklistListOfCompanies.trim() === '') {
            this.toastrService.error(
                'Please enter at least one company ID.'
            );
            this.isRunningChecklistBuild = false;
            this.checklistListOfCompanies = '';
            return;
        }

        const companies = this.checklistListOfCompanies.split(/\r?\n/);
        let progressCount = 0;
        try {
            for (const company of companies) {
                pushData.CompanyId = +company;
                ConsoleLogger.logInfo(pushData);
                try {
                    const response = await this.http
                        .post<any>(
                            `${environment.dotNetApiUrl}/${Area.transportation}/checklists/WithUnitSubChecklist`,
                            pushData
                        )
                        .toPromise();
                    ConsoleLogger.logInfo(response);
                    if (response == null) {
                        this.toastrService.warning(
                            `Company ${pushData.CompanyId} has no units to create a checklist from`
                        );
                    }
                    progressCount++;
                    this.checklistLoading = progressCount / companies.length;
                } catch (err) {
                    console.error('Error:', err);
                    progressCount++;
                    this.checklistLoading = progressCount / companies.length;
                    this.toastrService.error(
                        'Creating IFTA miles/fuel entry checklist failed to run.'
                    );
                }
            }

            this.toastrService.success(
                'Creating IFTA miles/fuel entry checklist successfully run.'
            );
            this.isRunningChecklistBuild = false;
            this.checklistListOfCompanies = '';
        } catch (error) {
            console.error('Error:', error);
            this.toastrService.error(
                'An error occurred while processing the checklist.'
            );
            this.isRunningChecklistBuild = false;
            this.checklistListOfCompanies = '';
        }
    }

    async createManyQuarterlyChecklist(pushData) {
        if (!this.checklistIftaQuarterlyListOfCompanies || this.checklistIftaQuarterlyListOfCompanies.trim() === '') {
            this.toastrService.error(
                'Please enter at least one company ID.'
            );
            this.isRunningChecklistBuild = false;
            this.checklistIftaQuarterlyListOfCompanies = '';
            return;
        }
        const companies = this.checklistIftaQuarterlyListOfCompanies.split(/\r?\n/);
        let progressCount = 0;
        try {
            for (const company of companies) {
                pushData.CompanyId = +company;
                pushData.UseIFTAAgent = true;
                ConsoleLogger.logInfo(pushData);
                try {
                    const response = await this.http
                        .post<any>(
                            `${environment.dotNetApiUrl}/${Area.transportation}/checklists/WithSubChecklist`,
                            pushData
                        )
                        .toPromise();
                    ConsoleLogger.logInfo(response);
                    progressCount++;
                    this.checklistLoading = progressCount / companies.length;
                } catch (err) {
                    console.error('Error:', err);
                    progressCount++;
                    this.checklistLoading = progressCount / companies.length;
                    this.toastrService.error(
                        'Creating IFTA quarterly filing checklist failed to run.'
                    );
                }
            }

            this.toastrService.success(
                'Creating IFTA quarterly filing checklist successfully run.'
            );
            this.isRunningChecklistBuild = false;
            this.checklistListOfCompanies = '';
        } catch (error) {
            console.error('Error:', error);
            this.toastrService.error(
                'An error occurred while processing the checklist.'
            );
            this.isRunningChecklistBuild = false;
            this.checklistListOfCompanies = '';
        }
    }

    createNyHutRenewalChecklist() {
        this.creatingChecklists = true;
        this.http
            .post<any>(
                `${environment.dotNetApiUrl}/${Area.transportation}/checklists/NyHutRenewalCreation`,
                {}
            )
            .subscribe(
                (x) => {
                    ConsoleLogger.logInfo(x);
                    this.checklistCount = x.length;
                    this.toastrService.success(
                        'Creating NY HUT checklists was successfully run.'
                    );
                    this.creatingChecklists = false;
                },
                (err) => {
                    console.error('Error:', err);
                    this.toastrService.error('Creating NY HUT checklists failed to run.');
                    this.creatingChecklists = false;
                }
            );
    }

    createNyHutRenewalChecklistSingle() {
        const pushData = {
            companyId: this.nyHutCompanyId,
            Year: this.nyHutYear,
        };
        this.isRunningChecklistBuild = true;
        this.http
            .post<any>(
                `${environment.dotNetApiUrl}/${Area.transportation}/checklists/NewYorkHutRenewalChecklistCreation`,
                pushData
            )
            .subscribe(
                (response) => {
                    ConsoleLogger.logInfo(response);
                    if (response == null) {
                        this.toastrService.warning(
                            `No NY HUT checklist created for company ${pushData.companyId}.`
                        );
                    } else {
                        this.toastrService.success(
                            'NY HUT renewal checklist successfully created.'
                        );
                    }
                    this.isRunningChecklistBuild = false;
                },
                (err) => {
                    this.isRunningChecklistBuild = false;
                }
            );
    }

    createOneIFTAMilesFuelChecklist(pushData) {
        ConsoleLogger.logInfo(pushData);
        this.http
            .post<any>(
                `${environment.dotNetApiUrl}/${Area.transportation}/checklists/WithUnitSubChecklist`,
                pushData
            )
            .subscribe(
                (response) => {
                    ConsoleLogger.logInfo(response);
                    if (response == null) {
                        this.toastrService.warning(
                            `Company ${pushData.CompanyId} has no units to create a checklist from.`
                        );
                    } else {
                        this.toastrService.success(
                            'Creating IFTA miles/fuel entry checklist successfully run.'
                        );
                    }
                    this.isRunningChecklistBuild = false;
                },
                (err) => {
                    console.error('Error:', err);
                    this.toastrService.error(
                        'Creating IFTA miles/fuel entry checklist failed to run.'
                    );
                    this.isRunningChecklistBuild = false;
                }
            );
    }

    createOneIFTAQuarterlyChecklist(pushData) {
        ConsoleLogger.logInfo(pushData);
        pushData.UseIFTAAgent = true;
        this.http
            .post<any>(
                `${environment.dotNetApiUrl}/${Area.transportation}/checklists/WithSubChecklist`,
                pushData
            )
            .subscribe(
                (response) => {
                    ConsoleLogger.logInfo(response);
                    this.toastrService.success(
                        'Creating IFTA quarterly filing checklist successfully run.'
                    );
                    this.isRunningChecklistBuild = false;
                },
                (err) => {
                    console.error('Error:', err);
                    this.toastrService.error(
                        'Creating IFTA quarterly filing checklist failed to run.'
                    );
                    this.isRunningChecklistBuild = false;
                }
            );
    }

    // NOTE: SCAC checklist creation is NOT exposed in the Auto-Create All dropdown.
    // The scheduled job (CreateSCACChecklists.cs) handles bulk creation with 90-day filtering.
    // If adding SCAC to the dropdown, backend CreateSCACChecklistUseCase will need an optional
    // filterBy90Days parameter to differentiate between manual bulk creation (false) and
    // scheduled job creation (true).
    createSCACChecklist(createAll: boolean) {
        let pushData = {};
        if (createAll) {
            pushData = { companyId: 0, year: this.scacYear };
        } else {
            pushData = { companyId: this.scacCompanyId, year: this.scacYear };
        }
        this.isRunningChecklistBuild = true;
        this.http
            .post<any>(
                `${environment.dotNetApiUrl}/${Area.transportation}/checklists/SCACChecklistCreation`,
                pushData
            )
            .subscribe(
                (response) => {
                    ConsoleLogger.logInfo(response);
                    if (response == null) {
                        this.toastrService.warning(
                            `No SCAC checklist was created.`
                        );
                    } else {
                        this.toastrService.success(
                            'Creating SCAC checklist successfully run.'
                        );
                    }
                    this.isRunningChecklistBuild = false;
                },
                (err) => {
                    console.error('Error:', err);
                    this.toastrService.error(
                        'Creating SCAC checklist failed to run.'
                    );
                    this.isRunningChecklistBuild = false;
                }
            );
    }

    createHAZMATChecklist(createAll: boolean) {
        let pushData = {};
        if (createAll) {
            pushData = { companyId: 0, year: this.hazmatYear };
        } else {
            pushData = { companyId: this.hazmatCompanyId, year: this.hazmatYear };
        }
        this.isRunningChecklistBuild = true;
        this.http
            .post<any>(
                `${environment.dotNetApiUrl}/${Area.transportation}/checklists/HAZMATChecklistCreation`,
                pushData
            )
            .subscribe(
                (response) => {
                    ConsoleLogger.logInfo(response);
                    if (response == null) {
                        this.toastrService.warning(
                            `No HAZMAT checklist was created.`
                        );
                    } else {
                        this.toastrService.success(
                            'Creating HAZMAT checklist successfully run.'
                        );
                    }
                    this.isRunningChecklistBuild = false;
                },
                (err) => {
                    console.error('Error:', err);
                    this.toastrService.error(
                        'Creating HAZMAT checklist failed to run.'
                    );
                    this.isRunningChecklistBuild = false;
                }
            );
    }

    createNMMTRRenewalChecklist(createAll: boolean) {
        let pushData = {};
        if (createAll) {
            pushData = { companyId: 0, year: this.nmMTRYear };
        } else {
            pushData = { companyId: this.nmMTRCompanyId, year: this.nmMTRYear };
        }
        this.isRunningChecklistBuild = true;
        this.http
            .post<any>(
                `${environment.dotNetApiUrl}/${Area.transportation}/checklists/NMMTRRenewalChecklistCreation`,
                pushData
            )
            .subscribe(
                (response) => {
                    ConsoleLogger.logInfo(response);
                    if (response == null) {
                        this.toastrService.warning(
                            `No NM MTR Renewal checklist was created.`
                        );
                    } else {
                        this.toastrService.success(
                            'Creating NM MTR Renewal checklist successfully run.'
                        );
                    }
                    this.isRunningChecklistBuild = false;
                },
                (err) => {
                    console.error('Error:', err);
                    this.toastrService.error(
                        'Creating NM MTR Renewal checklist failed to run.'
                    );
                    this.isRunningChecklistBuild = false;
                }
            );
    }

    createUcrChecklist(createAll: boolean) {
        let pushData = {};
        if (createAll) {
            pushData = { companyId: 0, year: this.ucrYear };
        } else {
            pushData = { companyId: this.ucrCompanyId, year: this.ucrYear };
        }
        this.isRunningChecklistBuild = true;
        this.http
            .post<any>(
                `${environment.dotNetApiUrl}/${Area.transportation}/checklists/UcrChecklistCreation`,
                pushData
            )
            .subscribe(
                (response) => {
                    ConsoleLogger.logInfo(response);
                    if (response == null) {
                        this.toastrService.warning(
                            `Company ${pushData} has no units to create a checklist from.`
                        );
                    } else {
                        this.toastrService.success(
                            'Creating UCR checklist successfully run.'
                        );
                    }
                    this.isRunningChecklistBuild = false;
                },
                (err) => {
                    this.isRunningChecklistBuild = false;
                }
            );
    }

    createUcrRenewalChecklist(createAll: boolean) {
        //ToDo: Set up this method to create the correct checklist. BP 09/25/2025 10:26 AM
        return;
    }

    create2290Checklist() {
        this.creatingChecklists = true;
        this.http
            .post<any>(
                `${environment.dotNetApiUrl}/${Area.transportation}/checklists/2290AutoCreation`,
                {}
            )
            .subscribe(
                (x) => {
                    ConsoleLogger.logInfo(x);
                    this.checklistCount = x.length;
                    this.toastrService.success(
                        'Creating 2290 checklists was successfully run.'
                    );
                    this.creatingChecklists = false;
                },
                (err) => {
                    console.error('Error:', err);
                    this.toastrService.error(
                        'Creating 2290 checklists failed to run.'
                    );
                    this.creatingChecklists = false;
                }
            );
    }

    makeFirstOfMonth() {
        if (this.checklistStartDate) {
            const inputDate = this.checklistStartDate.toISOString().split('T')[0];
            this.checklistStartDate = new Date(
                +inputDate.substring(0, 4),
                +inputDate.substring(5, 7) - 1,
                1
            );
            this.checklistEndDate = new Date(this.checklistStartDate);
            this.checklistEndDate = new Date(
                this.checklistEndDate.setMonth(
                    this.checklistEndDate.getMonth() + +this.checklistTermType
                )
            );
            this.checklistEndDate.setDate(0);
            this.checklistDueDate = new Date(this.checklistEndDate);
            this.checklistDueDate = new Date(
                this.checklistDueDate.setMonth(this.checklistDueDate.getMonth() + 2)
            );
            this.checklistDueDate.setDate(0);
            const newDate = new Date(this.checklistStartDate);
            newDate.setMonth(newDate.getMonth() + 2);
            this.irpMonth = newDate.toLocaleString('default', { month: 'long' });
            this.ucrYear =
                new Date().getMonth() >= 9
                    ? new Date().getFullYear() + 1
                    : new Date().getFullYear();
        }
    }

    runCreateAllMonthlyIftaFuelChecklist() {
        this.creatingChecklists = true;
        this.http
            .post<any>(
                `${environment.dotNetApiUrl}/${Area.transportation}/checklists/IftaMilesFuelChecklistMonthlyCreation`,
                {}
            )
            .subscribe(
                (x) => {
                    ConsoleLogger.logInfo(x);
                    this.checklistCount = x.length;
                    this.toastrService.success(
                        'Creating IFTA fuel entry checklists was successfully run.'
                    );
                    this.creatingChecklists = false;
                },
                (err) => {
                    console.error('Error:', err);
                    this.toastrService.error(
                        'Creating IFTA fuel entry checklists failed to run.'
                    );
                    this.creatingChecklists = false;
                }
            );
    }

    runCreateAllMtrMonthlyChecklist() {
        this.creatingChecklists = true;
        this.http
            .post<any>(
                `${environment.dotNetApiUrl}/${Area.transportation}/checklists/MtrMonthlyChecklistMonthlyCreation`,
                {}
            )
            .subscribe(
                (x) => {
                    ConsoleLogger.logInfo(x);
                    this.checklistCount = x.length;
                    this.toastrService.success(
                        'Creating MTR monthly checklists was successfully run.'
                    );
                    this.creatingChecklists = false;
                },
                (err) => {
                    console.error('Error:', err);
                    this.toastrService.error(
                        'Creating MTR monthly checklists failed to run.'
                    );
                    this.creatingChecklists = false;
                }
            );
    }

    runCreateAllIftaQuarterlyChecklist() {
        this.creatingChecklists = true;
        this.http
            .post<any>(
                `${environment.dotNetApiUrl}/${Area.transportation}/checklists/IftaMilesQuarterlyChecklistMonthlyCreation`,
                {}
            )
            .subscribe(
                (x) => {
                    ConsoleLogger.logInfo(x);
                    this.checklistCount = x.length;
                    this.toastrService.success(
                        'Creating IFTA quarterly checklists was successfully run.'
                    );
                    this.creatingChecklists = false;
                },
                (err) => {
                    console.error('Error:', err);
                    this.toastrService.error(
                        'Creating IFTA quarterly checklists failed to run.'
                    );
                    this.creatingChecklists = false;
                }
            );
    }

    runSelectedTask() {
        this.checklistCount = 0;

        if (this.selectedTask && this.selectedTask.action) {
            this.selectedTask.action();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/developer/components/developer-tools/create-checklists/create-checklists.component.ts